export function d7Order() {
  if (!window || !window._d7)
  {
    return;
  }

  window._d7.push({
    action:     'order',
    orderId:    '',
    totalPrice: '',
    currency:   '',
    items:      [],
    pageId:     $('.current-page-tracking').val(),
  });
}
